import Logger from './logger.service'

export default class LocalStorageService {
  static getItemForUserIdElseDatabaseUserName(userId: string, username: string, keySuffix: string): string | null {
    if (userId) {
      const keyForUserId = `${userId}:${keySuffix}`
      const valueForUserId = localStorage.getItem(keyForUserId)

      if (valueForUserId) {
        return valueForUserId
      }
    }

    const keyForUserName = `${username}:${keySuffix}`
    return LocalStorageService.getItemCaseInsensitive(keyForUserName)
  }

  static getItemCaseInsensitive(keyToFind: string): string | null {
    const lowerKeyToFind = keyToFind.toLowerCase()

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)

      if (key && key.toLowerCase() === lowerKeyToFind) {
        return localStorage.getItem(key)
      }
    }

    return null
  }

  static setItemForUserIdAndCleanDatabaseUserName(userId: string, username: string, keySuffix: string, value: string) {
    const newKey = `${userId}:${keySuffix}`
    localStorage.setItem(newKey, value)

    const keyToClean = `${username}:${keySuffix}`
    LocalStorageService.cleanLocalStorageKey(keyToClean)
  }

  private static cleanLocalStorageKey(keyToClean: string) {
    const lowerKeyToClean = keyToClean.toLowerCase()

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)

      if (key && key.toLowerCase() === lowerKeyToClean) {
        localStorage.removeItem(key)
        Logger.info(`Removed key [${key}] from localStorage`)

        i--
      }
    }
  }
}
